<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
				<b-nav-item class="filter" role="presentation" @click.prevent="searchFilterButtonClick" href="#">
					<i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i>
				</b-nav-item>
				</template>
			</b-tabs>

		</div>

		<div class="row">
			<div class="col-md-12 search form minimize"> 
							
				<form class="search bright formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-12 form-group">
							<ReportParamSearch title="Keagenan" v-model="branch" :options="keagenan.list" fldid="BranchId" fldinfo="BranchName" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Locations" name="detail1" v-model="detail1" :options="options.detail1" />
						</div>
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
						</div>
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Channel" name="channel" v-model="channel" :options="options.channel" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 form-group">
							<ReportParamDateRange title="Date" v-model="date" />
						</div>
						<div class="col-md-6 form-group">
							<ReportParamSelect title="Periods" name="period" v-model="period" :options="options.period" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-3 form-group">
							<ReportParamSelect title="PSO" name="pso" v-model="pso" :options="options.pso" />
						</div>
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Items" name="detail2" v-model="detail2" :options="options.detail2" />
						</div>
						<div class="col-md-6 form-group" v-if="tabIndex==0">
							<ReportParamSelect title="Source" name="source" v-model="source" :options="options.source" />
						</div>
					</div>

				</form>
			</div> 
			
		</div> 
		<div class="row" v-if="tabIndex<2">
			<div class="col-md-6"><input type="checkbox" v-model="showchart"> Show Chart </div>
			<div class="col-md-6" v-if="showchart"><input type="checkbox" v-model="stacked"> Stacked </div>
		</div> 
		<LineChart :data="chartdata" :width="500" :height="280" v-if="showchart && tabIndex<2" />
		
		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="BrightReport" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import LPG from '@/components/page/LPG.js'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import LineChart from '@/components/chart/BarChart.js'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, Rainbow2, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'

export default
{
	extends:LPG,
	components: {
		LineChart,
		ReportParamSelect,
		ReportResultTable,
		ReportParamSearch,
		ReportParamDateRange,
		Loader,
	},
	data() {
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'yearly', name: 'YEARLY' },
				],
				channel:[
					{ value: "", name: "ALL" }, 
					{ value: "channel", name: "BY CHANNEL" }, 
					{ value: "OTHER", name: "OTHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "SPBU", name: "SPBU" }, 
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA" }, 
					{ value: "province", name: "BY PROVINCE" }, 
					{ value: "store", name: "BY BRANCH" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "item", name: "BY ITEM" }
				],
				pso:[
					{ value: "", name: "ALL" }, 
					{ value: "bypso", name: "BY PSO" },
					{ value: "PSO", name: "PSO" },
					{ value: "NONPSO", name: "NON PSO" },
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				source:[
					{ value: "", name: "ALL" }, 
					{ value: "source", name: "BY SOURCE" }, 
					{ value: "KEAGENAN", name: "KEAGENAN" }, 
					{ value: "VENDOR", name: "VENDOR" }, 
				],
			},
			tabList:[
				{name:'Sales LPG'},
				{name:'Sales Keagenan'},
				{name:'Margin Keagenan'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			branch: this.$route.query.branch ? this.$route.query.branch : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			channel: this.$route.query.channel ? this.$route.query.channel : '',
			pso: this.$route.query.pso ? this.$route.query.pso : 'bypso',
			source: this.$route.query.source ? this.$route.query.source : '',
		}
	},
	computed:
	{
	},
	watch:
	{
		tabIndex() { this.resumePilihan() },
		date(){ this.resumePilihan() },
		branch() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
	},      
	mounted(){
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
		document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		this.$emit('childrenRoute')
		
		this.loadKeagenanList()
		this.resumePilihan()
	},
	methods:{

		refreshChart() {
			let a = this.detail2 == "item" ? "ItemName" : "StatusPSO"
			let b = "Period"
			let c = Rainbow
			
			if (!this.period) {
				b = "Channel"
			}
			if (this.channel == "channel") {
				a = "Channel"
				c = Rainbow2
			}
			else if (this.tabIndex == 0 && this.source == "source") {
				a = "Source"
				c = Rainbow2
			}
			if (this.detail1 == "area") {
				a = "SalesArea"
			}
			else if (this.detail1 == "province") {
				a = "ProvinceName"
			}
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "TotalSalesExTax", false, b, "", 1000000, 2, c, false, false, false, this.stacked);
		},

		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
				
		resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/lpg/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/lpg/sales2?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/lpg/margin?'
			
			this.urlRequestParams+='&date-range-start='+this.date.Start
			this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&channel='+this.channel
			this.urlRequestParams+='&branch='+this.branch
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&pso='+this.pso
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2

			if (this.tabIndex == 0) this.urlRequestParams+='&source='+this.source

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				this.reportdata = response.data;
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.table = false;
			})

		},

		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})            
		}
	}
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.75) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
.search.form { background:#f8f9fa; border-radius:0px 0px 5px 5px; color:#666; padding:20px;   transition: all 0.5s ease-in-out;}
.search.form.minimize{ padding:0px; height:2px; overflow:hidden; }
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }
    

.search.form.floating {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 750px;
    height: 300px;
    z-index: 9;
    background: rgba(172,196,55,.75);
    padding: 20px;
    border-radius: 15px 15px 0px 15px;
    overflow-Y: scroll;
    }
    .table .card .card-header{ display:none;}
    .table .card .card-body{ padding: 0px;}
    .table.pdf{ border:0px; }
    .table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
    .table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }
    
    .table.pdf thead tr{ background: #ccc; color:#333;}
 

    .filter .icon-up { display: flex; }
    .filter.down .icon-up { display: none; }
    .filter .icon-down { display: none; }
    .filter.down .icon-down { display: flex; }


</style>